import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=8457b6b8&scoped=true&"
import script from "./profile.ts?vue&type=script&lang=ts&"
export * from "./profile.ts?vue&type=script&lang=ts&"
import style0 from "./profile.vue?vue&type=style&index=0&id=8457b6b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8457b6b8",
  null
  
)

export default component.exports